<mat-card appearance="outlined">
    <div class="header">
        <div>
            <mat-card-title>
                <strong>Resources</strong>
            </mat-card-title>
        </div>
        <div class="header-spacer"></div>
        <span *ngIf="canEdit" class="pull-right">
            <button
                mat-icon-button
                [attr.aria-label]="listSaveEditLabel(isEditing)"
                [matTooltip]="isEditing ? 'Save your changes' : 'Edit list'"
                (click)="click()"
            >
                <mat-icon>{{ isEditing ? Icons.Save : Icons.Edit }}</mat-icon>
            </button>
        </span>
    </div>
    <mat-card-content>
        <mat-progress-bar
            *ngIf="!resources || isSaving"
            mode="indeterminate"
            aria-label="resource progress"
        ></mat-progress-bar>
        <div *ngIf="error" class="error">
            <em>Error: {{ error }}</em>
        </div>
        <div *ngIf="resources">
            <div
                cdkDropList
                *ngIf="hasResources(); else empty"
                [cdkDropListData]="resources"
                (cdkDropListDropped)="drop($event)"
            >
                <div
                    *ngFor="let resource of resources; index as i"
                    [cdkDragDisabled]="!isEditing"
                    class="boxed"
                    cdkDrag
                >
                    <div *ngIf="resource.active" class="row">
                        <ng-container
                            [ngTemplateOutlet]="isEditing ? update : link"
                            [ngTemplateOutletContext]="{
                                resource: isEditing ? resources[i] : resource,
                            }"
                        ></ng-container>
                    </div>
                </div>
            </div>
        </div>
    </mat-card-content>
    <mat-card-actions *ngIf="canEdit">
        <button
            mat-icon-button
            aria-label="Add resource"
            (click)="openNewResourceDialog()"
        >
            <mat-icon>add</mat-icon>
        </button>
    </mat-card-actions>
</mat-card>

<ng-template #empty>{{ error ? null : "No Resources Found" }}</ng-template>

<ng-template #newDialog>
    <h1 mat-dialog-title>Create new resource</h1>
    <div mat-dialog-content>
        <form [formGroup]="resourceForm">
            <mat-form-field class="form-field">
                <mat-label>Enter a resource name</mat-label>
                <input matInput [formControl]="resourceName" />
            </mat-form-field>
            <br />
            <mat-form-field class="form-field">
                <mat-label>Enter a resource location</mat-label>
                <input
                    matInput
                    [formControl]="resourcePath"
                    [placeholder]="locationPlaceholder"
                    [errorStateMatcher]="pathMatcher"
                />
                <mat-error
                    *ngIf="
                        resourcePath.hasError('path') &&
                        !resourcePath.hasError('required')
                    "
                >
                    The resource path must begin with https:// or //.
                </mat-error>
            </mat-form-field>
        </form>
    </div>
    <div mat-dialog-actions>
        <button
            mat-button
            [disabled]="resourceForm.invalid"
            (click)="createNewResource()"
        >
            Save
        </button>
        <button mat-button mat-dialog-close>Cancel</button>
    </div>
</ng-template>

<ng-template #link let-resource="resource">
    <a
        href="{{ resource.path }}"
        lasLink
        [attr.aria-label]="'View resource ' + resource.name"
        >{{ resource.name }}</a
    >
</ng-template>

<ng-template #update let-resource="resource">
    <a
        [routerLink]=""
        (click)="openNewResourceDialog(resource)"
        [attr.aria-label]="'Edit resource ' + resource.name"
    >
        {{ resource.name }}
    </a>
    <button (click)="deactivateResource(resource)" mat-icon-button>
        <mat-icon>close</mat-icon>
    </button>
</ng-template>
